<template>
  <a-modal
    :title="obj ? '编辑业务平台' : '创建业务平台'"
    :visible="visible"
    :confirmLoading="confirmLoading"

    okText="提交"
    cancelText="取消"
    @ok="handlerSubmit"
    @cancel="() => $emit('hideModal')"

    :afterClose="afterHideEditModal"
  >
    <a-form-model
      ref="editForm"
      :model="editForm"
      :rules="editFormRules"
      :label-col="{ span: 5 }"
      :wrapper-col="{ span: 18 }"
    >
      <a-form-model-item label="名称" prop="name">
        <a-input v-model="editForm.name" placeholder="请填写名称" />
      </a-form-model-item>

      <a-form-model-item label="通知地址" prop="notifyUrl">
        <a-textarea v-model="editForm.notifyUrl" placeholder="请填写通知地址" ></a-textarea>
      </a-form-model-item>
    </a-form-model>
  </a-modal>
</template>

<script>

const editForm = {
  id: undefined,
  name: undefined,
  notifyUrl: undefined,
}
const editFormRules = {
  name: [{ required: true, message: '请填写名称！' }],
  notifyUrl: [{ required: true, message: '请填写通知地址！' }],
}


export default {
  name: 'EditModal',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    obj: {
      type: Object,
      default: () => null
    }
  },
  data () {
    return {
      editForm,
      editFormRules,
      uploading: false,
      confirmLoading:false
    }
  },
  computed: {},
  watch: {
    visible: function (val){
      if (val && this.obj){
        this.$nextTick(() => {
          const { id, name, notifyUrl } = this.obj
          this.editForm = { id, name, notifyUrl }
        })
      }
    }
  },
  created() {},
  methods: {
    // 提交模态框数据
    handlerSubmit() {
      this.$refs.editForm.validate(async valid => {
        if (valid) {
          this.$emit('submit', this.editForm)
          this.confirmLoading = true
        }
      })
    },
    // 编辑终端标识组模态框关闭后，重置相关数据
    afterHideEditModal() {
      this.$refs.editForm.resetFields()
      this.editForm = editForm
      this.confirmLoading = false
    },
  }
}
</script>

<style lang="less" scoped>
  ::v-deep .ant-modal{
    width: 700px !important
  }
  ::v-deep .ant-form-item{
    margin-bottom: 12px;
  }
  .ant-checkbox-group>.ant-checkbox-wrapper:first-child{
    margin-left: 8px !important;
  }
</style>
